import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const CASCADING_SELECT_FRAGMENT = gqlTagGira`
    fragment jiraCascadingSelectFieldFragment on JiraCascadingSelectField {
        id
        fieldId
        fieldConfig {
            isEditable
        }
        cascadingOption {
            parentValue {
                id
                isDisabled
                value
            }
            childOptionValue {
                id
                optionId
                isDisabled
                value
            }
        }
    } 
`;
